import "./css/feature.css";

const Feature = ({
  feature_key,
  heading,
  content,
  img_url,
  shouldBackgroundImageBeOnBottom,
  bg,
  data_index,
}) => {
  return (
    <div
      className={`feature${shouldBackgroundImageBeOnBottom ? " tall" : ""}${
        heading.toLowerCase() === "e-Library system".toLowerCase()
          ? " e_library"
          : ""
      }
      ${
        heading.toLowerCase() === "Student Information System".toLowerCase() ?
        " mobile_sis" : ""
      }${
        heading.toLowerCase() === "Parent Management System".toLowerCase() ?
        " mobile_parent" : ""
      }${
        heading.toLowerCase() ===
          "School Admin Management System".toLowerCase() ?
        " mobile_school_admin_mngt" : ""
      }${
        heading.toLowerCase() ===
          "Safe & Secure payment for Parents".toLowerCase() ?
        " mobile_safe_and_secure" : ""
      }${
        heading.toLowerCase() ===
          "Advanced Course Management tools".toLowerCase() ?
        " mobile_advanced_course" : ""
      }
      `}
      data_index={data_index}
      style={{ 
        overflow:
          heading.toLowerCase() !== "Parent Management System".toLowerCase()
            ? "hidden"
            : "unset",
        backgroundImage: `url('${img_url}')`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: shouldBackgroundImageBeOnBottom ? "0 100%" : "100% 120%",
        backgroundSize: shouldBackgroundImageBeOnBottom ? "100% auto": "auto 80%"
      }}
    >
      <div className="heading_and_content">
        <h3>{heading}</h3>
        <p>{content}</p>
      </div>
      {/* <div
        className={`image_container${
          heading.toLowerCase() === "e-Library system".toLowerCase()
            ? " displayed_none"
            : ""
        }${
          heading.toLowerCase() ===
          "Advanced Course Management tools".toLowerCase()
            ? " no_top_or_right"
            : ""
        }`}
      >
        <img src={img_url} alt={heading} />
      </div> */}
    </div>
  );
};

export default Feature;
